import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSleutelAanvragen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8C9E9"
      fillRule="evenodd"
      d="m19.17 18.38 4.14 15.13-7.36 2.01-1.34-4.9 2.45-.67-2.8-10.23c-3.13-.23-5.93-2.39-6.8-5.6-1.11-4.06 1.28-8.26 5.34-9.37s8.26 1.28 9.37 5.34c.88 3.2-.43 6.49-3.01 8.28zm-5.02-8.72a2.544 2.544 0 0 0-1.78 3.12 2.544 2.544 0 0 0 3.12 1.78 2.544 2.544 0 0 0 1.78-3.12 2.544 2.544 0 0 0-3.12-1.78"
      clipRule="evenodd"
    />
    <path
      fill="#F29FC5"
      fillRule="evenodd"
      d="m21.7 15.39 11.11 11.08-5.39 5.4-3.6-3.59 1.8-1.8-7.51-7.49A7.629 7.629 0 0 1 9.42 6.72a7.629 7.629 0 0 1 12.29 8.67zm-8.69-5.08c-.99.99-.99 2.6 0 3.6s2.6.99 3.6 0c.99-.99.99-2.6 0-3.6s-2.6-.99-3.6 0"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSleutelAanvragen);

export default ForwardRef;
